import {useMemo} from 'react';
import {useAllApps} from '../../../../hooks/useApps';
import {useSelector} from 'react-redux';
import {useQuery} from 'react-query';
import {fetchBAASWalletSettlement} from '../../../../requests/queries/baas';

export const useBaasSettlement = (selectedCurrency = {}) => {
  const {userApps, isLoading: appsLoading} = useAllApps();
  const {userDetails} = useSelector(state => state?.auth || {});

  const appIds = useMemo(
    () => (!appsLoading && userApps?.length > 0 ? userApps[0]?.value : ''),
    [appsLoading, userApps],
  );

  const currencyCode = selectedCurrency?.code || 'NGN';

  const settlementParams = useMemo(
    () => ({
      company_id: userDetails?.company?.id,
      ...(appIds && {app_id: appIds}),
      ...(currencyCode && {currency: currencyCode}),
    }),
    [appIds, userDetails, currencyCode],
  );

  const {
    data: settlement,
    isLoading: isSettlementLoading,
    isFetching,
  } = useQuery(
    ['baas-settlement', settlementParams],
    () => fetchBAASWalletSettlement({params: settlementParams}),
    {
      meta: {preventGlobalError: true},
      enabled: !!appIds && !!currencyCode && !!userDetails?.company?.id,
    },
  );

  const user_account = useMemo(
    () => (!isSettlementLoading && settlement ? settlement?.entity : null),
    [isSettlementLoading, settlement],
  );

  return {user_account, isSettlementLoading, isFetching};
};
